import { CircularProgressSize } from '@/constants/circularProgressTypes';
import { CircularProgress as MuiCircularProgress, styled } from '@mui/material';
import { assertNever } from '@/utils/assertNever';

interface CircularProgressProps {
  size?: CircularProgressSize;
}

const sizeInPx = (size: CircularProgressSize): number => {
  switch (size) {
    case CircularProgressSize.SMALL:
      return 16;
    case CircularProgressSize.LARGE:
      return 32;
    default:
      return assertNever(size);
  }
};

export const CircularProgress: React.FC<CircularProgressProps> = ({ size = CircularProgressSize.LARGE }) => (
  <StyledCircularProgress size={sizeInPx(size)} />
);

const StyledCircularProgress = styled(MuiCircularProgress)(({ theme, size }) => ({
  color: theme.palette.primary.main,
  width: size,
  height: size,
}));
